import React from 'react';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import MobileNullView from './MobileNullView';
import DesktopNullView from './DesktopNullView';

const ProjectsNullView = ({ componentId, isCompactView, isDashboardSnapshot }) => {
  const { ref, clickID } = useImpression({
    data: {
      component: 'ProjectsNullView',
      name: 'ProjectsNullView',
      id: componentId || '',
      position: 1,
      type: 'content'
    }
  });

  return (
    <div
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      className="sui-h-full"
    >
      {isCompactView ? (
        <MobileNullView componentId={componentId} isDashboardSnapshot={isDashboardSnapshot} />
      ) : (
        <DesktopNullView componentId={componentId} isDashboardSnapshot={isDashboardSnapshot} />
      )}
    </div>
  );
};

ProjectsNullView.propTypes = {
  componentId: PropTypes.string,
  isCompactView: PropTypes.bool,
  isDashboardSnapshot: PropTypes.bool
};

ProjectsNullView.defaultProps = {
  componentId: '',
  isCompactView: true,
  isDashboardSnapshot: false
};

export default ProjectsNullView;
